import arrayBufferToString from './arrayBufferToString';

/**
 * Converts an `ArrayBuffer` to a base 64 string.
 */

const arrayBufferToBase64 = (input: ArrayBuffer|Uint8Array) => window.btoa(arrayBufferToString(input));

export default arrayBufferToBase64;